// extracted by mini-css-extract-plugin
export default {"scl_page":"scl_page__9a1b0d48","cs":"cs__9a1b0d48","step_img":"step_img__9a1b0d48"};